import { GridColumn } from '@progress/kendo-react-grid'
import React, { useState } from 'react'
import { ListScreen } from '../../components';
import { useParams } from 'react-router-dom';

const ConstChild = () => {

    const { code } = useParams()
    const [usersenddata] = useState({ parent_code: code });

    return (
        <div>
            <ListScreen
                read={'co000002'}
                delete={'co000004'}
                userSendData={usersenddata}
                showDetail={code === 'SETTINGS'}
            >
                <GridColumn field='name' />
                <GridColumn field='code' />
                <GridColumn field='value' />
            </ListScreen>
        </div>
    )
}

export default ConstChild